import React, { useMemo, useState } from 'react';
import { ButtonBar, Button } from '../../../../common/components';
import { intersection } from 'lodash';
import { useSelector } from 'react-redux';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { CheckSelectNotRedux } from '../../../../common/components/CheckSelect/CheckSelect';

const getOptions = (optionsList) => {
  return optionsList.reduce(
    (carry, option) => {
      // const option = options[id];

      if (option.attributes.is_selected) {
        carry.answers.push(option.attributes.number);
      }

      if (option.attributes.is_forward === false) {
        carry.radio.push(option.attributes.number);
      }

      if (option.attributes.is_disabled && option.attributes.is_forward) {
        carry.answers.push(option.attributes.number);
      }
      return carry;
    },
    {
      answers: [],
      radio: [],
    },
  );
};
export const MultipleChoiceQuestion = ({
  conditionNumber,
  questionNumber,
  optionsList,
  text,
  info,
  onSetAnswer,
}) => {
  // radio - Elements that will cause the question to submit automatically and clear other choices
  const { answers: initialAnswers, radio } = useMemo(() => getOptions(optionsList), [
    optionsList,
  ]);
  const [answers, setAnswers] = useState(initialAnswers);
  const { isSubmitting } = useSelector((state) => state.screening);

  const handleCheckboxTick = (optionAnswer) => {
    const position = answers.indexOf(optionAnswer);
    if (position > -1) {
      setAnswers(
        answers.filter((val) => {
          return val !== optionAnswer;
        }),
      );
    } else {
      if (radio.indexOf(optionAnswer) > -1) {
        setAnswer([optionAnswer]);
        return;
      }

      if (intersection(answers, radio).length > 0) {
        setAnswers([optionAnswer]);
        return;
      }

      setAnswers([...answers, optionAnswer]);
    }
  };

  const setAnswer = (newAnswers) => {
    onSetAnswer(conditionNumber, questionNumber, {
      id: newAnswers.join(';'),
    });
  };

  const handleSubmit = () => {
    setAnswer(answers);
  };

  return (
    <>
      <Row className={'question'}>
        <Col sm={12}>
          <ControlLabel>{text}</ControlLabel>
          {info && (
            <p className="text-info text-justify" style={{ fontSize: '14px' }}>
              {info}
              <br />
            </p>
          )}
        </Col>
      </Row>
      <div className="multi-select-container">
        <Row>
          <Col sm={12}>
            <div className="radio-container-boolean-question">
              {optionsList.map((option) => (
                <CheckSelectNotRedux
                  key={option.attributes.number}
                  label={option.attributes.text}
                  value={option.attributes.number}
                  checked={answers.includes(option.attributes.number)}
                  onChange={handleCheckboxTick}
                  disabled={option.attributes.is_disabled}
                />
              ))}
            </div>
          </Col>
        </Row>
      </div>
      <ButtonBar>
        <Button
          bsStyle="primary"
          isLoading={isSubmitting}
          label="Submit"
          handleClick={handleSubmit}
        />
      </ButtonBar>
    </>
  );
};
